import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, BookOpenIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function LeadMagnet() {
  return <section className="bg-brand-light py-16 lg:py-20 relative overflow-hidden" data-id="element-133">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full" data-id="element-134">
        <div className="absolute top-12 left-[10%] w-32 h-32 border border-gold/20 rounded-full" data-id="element-135"></div>
        <div className="absolute bottom-16 right-[8%] w-48 h-48 border border-gold/15 rounded-full" data-id="element-136"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl" data-id="element-137"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-139">
          <div className="inline-flex items-center gap-2 bg-navy text-gold font-inter font-bold text-[17px] uppercase tracking-widest px-5 py-2 rounded-md mb-6" data-id="element-140">
            <SparklesIcon className="w-4 h-4" data-id="element-141" />
            EVALUARE GRATUITĂ SIMPLIFICATĂ
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-navy mb-5" data-id="element-142">
            Fă primul pas către o versiune
            <br className="hidden md:block" data-id="element-143" /> îmbunătățită a ta
          </h2>
          <p className="font-inter text-text-medium text-[19px] leading-relaxed max-w-2xl mx-auto" data-id="element-144">
            Programează o sesiune scurtă de evaluare (20-30 de minute, online
            sau în cabinet) în care afli exact ce îți blochează energia,
            greutatea sau claritatea mentală. Primești un plan de acțiune
            personalizat, fără nicio obligație.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-145">
          {/* Evaluare Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl border border-border-subtle shadow-md p-10 flex flex-col items-start hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group" data-id="element-146">
            <div className="w-16 h-16 rounded-2xl bg-navy flex items-center justify-center mb-8 shadow-lg" data-id="element-147">
              <CalendarIcon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-148" />
            </div>
            <h3 className="font-montserrat font-bold text-navy text-2xl mb-3 text-center md:text-left" data-id="element-149">
              Evaluare Gratuită
            </h3>
            <p className="font-inter text-text-medium text-[19px] leading-relaxed mb-8 flex-1" data-id="element-150">
              20-30 de minute, online sau în cabinet. Identificăm blocajele
              principale și primești primele recomandări personalizate.
            </p>
            <a href="https://nutrisib.club/formular" className="flex items-center gap-3 bg-gold text-navy font-inter font-bold uppercase tracking-wide text-[15px] px-6 py-4 rounded-xl hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 w-full justify-center whitespace-nowrap no-underline" data-id="element-151">
              Programează Evaluarea Cadou
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-152" />
            </a>
          </motion.div>

          {/* Blog Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="bg-white rounded-2xl border border-border-subtle shadow-md p-10 flex flex-col items-start hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group" data-id="element-153">
            <div className="w-16 h-16 rounded-2xl bg-brand-light flex items-center justify-center mb-8 shadow-lg" data-id="element-154">
              <BookOpenIcon className="w-8 h-8 text-navy" strokeWidth={1.5} data-id="element-155" />
            </div>
            <h3 className="font-montserrat font-bold text-navy text-2xl mb-3 text-center md:text-left" data-id="element-156">
              Articole & Resurse
            </h3>
            <p className="font-inter text-text-medium text-[19px] leading-relaxed mb-8 flex-1" data-id="element-157">
              Explorează articolele de pe blog despre nutriție, energie,
              suplimentare și optimizare metabolică. Informație bazată pe
              știință, nu pe tendințe.
            </p>
            <a href="https://nutrisib.club/blog" className="flex items-center gap-3 bg-transparent border-2 border-navy text-navy font-inter font-bold uppercase tracking-wide text-[15px] px-6 py-4 rounded-xl hover:bg-navy hover:text-white transition-all duration-200 w-full justify-center whitespace-nowrap no-underline" data-id="element-158">
              Citește Articolele de pe Blog
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-159" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}